/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_JuneInputs */

const es_months_june = /** @type {(inputs: Months_JuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junio`)
};

const en_months_june = /** @type {(inputs: Months_JuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`June`)
};

/**
* | output |
* | --- |
* | "June" |
*
* @param {Months_JuneInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_june = /** @type {((inputs?: Months_JuneInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_JuneInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_june(inputs)
	return en_months_june(inputs)
});
export { months_june as "months.june" }